// Translation: Turkish > Time
const time = Object.freeze({
	day: 'Gün',
	dayInShort: 'G',
	dayWithType: '{{type}} günü',
	frequencyItems: {
		once: 'Bir defa',
		perUse: 'Kullanım başına'
	},
	hour: 'Saat',
	hourInShort: 'sa',
	hourWithType: '{{type}} saati',
	minute: 'Dakika',
	minuteInShort: 'd',
	minuteWithType: '{{type}} dakikası',
	month: 'Ay',
	monthInShort: 'A',
	monthWithType: '{{type}} ayı',
	rangeItems: {
		last24Hours: 'Son 24 saat',
		last30Days: 'Son 30 gün',
		last7Days: 'Son 7 gün',
		thisMonth: 'Bu ay',
		thisWeek: 'Bu hafta',
		thisYear: 'Bu yıl',
		today: 'Bugün'
	},
	second: 'Saniye',
	secondInShort: 'sn',
	secondWithType: '{{type}} saniyesi'
})

// Export
export default time
